module.exports = __webpack_public_path__ + "img/visa.48cf6e9.png";